import { z } from 'zod';
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const words = (max) => z.string().trim().min(1).max(max);
const paise = z.number().int().min(0).max(Number.MAX_SAFE_INTEGER);
/**
 * What the broker records about a deal beyond the money. All of it is a record of what people said:
 * the app does not check any of it, and it never holds or moves the token.
 */
export const dealFactsSchema = z
    .object({
    /** In plain words, what happens to the token if either side backs out, and by when it is returned. */
    tokenTerms: z
        .object({
        ownerBacksOut: words(300),
        tenantBacksOut: words(300),
        returnedBy: isoDate,
    })
        .optional(),
    /** Told by the broker: where the tenant works, whether the broker saw an ID, how many will stay. */
    tenant: z
        .object({
        occupation: words(120).nullable().optional(),
        idSeen: z.enum(['yes', 'no']).nullable().optional(),
        people: z.number().int().min(1).max(30).nullable().optional(),
    })
        .optional(),
    deposit: z
        .object({
        amountPaise: paise.nullable().optional(),
        paidTo: words(80).nullable().optional(),
        date: isoDate.nullable().optional(),
        refundTerms: words(300).nullable().optional(),
    })
        .optional(),
    /** The broker's RERA registration number, asked for on a sale. Recorded as given, never checked. */
    reraNumber: words(40).nullable().optional(),
    /** A plain checklist item. No claim of filing and no legal text. */
    police: z
        .object({
        status: z.enum(['not_yet', 'done_by_broker', 'done_by_owner']),
        date: isoDate.nullable().optional(),
        note: z.string().trim().max(200).nullable().optional(),
    })
        .optional(),
})
    .strict();
/** True when the token terms are complete: the memo cannot go out without them. */
export function tokenTermsComplete(facts) {
    const t = facts.tokenTerms;
    return (t !== undefined && t.ownerBacksOut !== '' && t.tenantBacksOut !== '' && t.returnedBy !== '');
}
//# sourceMappingURL=deal-facts.js.map